import { getNodeCategory } from './csmlNodeCategories';
import { isNodeTypeSupported } from './csmlNodeSupport';

/**
 * Default node templates for the CSML visual builder.
 * Ported from builder4.html nodeTemplates.
 */

export const NODE_TEMPLATE_TYPES = [
  'start',
  'say',
  'typing',
  'image',
  'question',
  'quickreply',
  'video',
  'audio',
  'file',
  'url',
  'carousel',
  'calendar',
  'input',
  'radio',
  'multiselect',
  'checkbox',
  'dropdown',
  'latex',
  'signature',
  'userinput',
  'api',
  'assign',
  'oauth',
  'hold',
  'router',
  'workinghours',
];

export const nodeTemplates = {
  start: {
    type: 'start',
    label: 'Start',
    icon: 'i-lucide-play',
    content: 'Welcome! How can I help?',
  },
  say: {
    type: 'say',
    label: 'Say',
    icon: 'i-lucide-message-circle',
    content: 'Hello world! **bold** _italic_ [link](url)',
  },
  typing: {
    type: 'typing',
    label: 'Typing',
    icon: 'i-lucide-ellipsis',
    content: '1000',
    duration: 1000,
  },
  image: {
    type: 'image',
    label: 'Image',
    icon: 'i-lucide-image',
    content: '',
  },
  question: {
    type: 'question',
    label: 'Question',
    icon: 'i-lucide-circle-help',
    content: 'Choose an option:',
    buttons: [
      { label: 'Option 1', payload: 'btn1' },
      { label: 'Option 2', payload: 'btn2' },
    ],
  },
  quickreply: {
    type: 'quickreply',
    label: 'QuickReply',
    icon: 'i-lucide-reply',
    content: 'Pick one:',
    buttons: [
      { label: 'Yes', payload: 'yes' },
      { label: 'No', payload: 'no' },
    ],
  },
  video: {
    type: 'video',
    label: 'Video',
    icon: 'i-lucide-video',
    content: '',
  },
  audio: {
    type: 'audio',
    label: 'Audio',
    icon: 'i-lucide-music',
    content: '',
  },
  file: {
    type: 'file',
    label: 'File',
    icon: 'i-lucide-file-text',
    content: '',
  },
  url: {
    type: 'url',
    label: 'Url',
    icon: 'i-lucide-link',
    content: 'https://www.wikipedia.org/',
    urlText: 'Visit Wikipedia',
    hideUrl: false,
  },
  carousel: {
    type: 'carousel',
    label: 'Carousel',
    icon: 'i-lucide-gallery-horizontal',
    content: 'Product carousel',
    cards: [
      {
        title: 'Card 1',
        subtitle: 'Sub',
        image_url: 'https://via.placeholder.com/150',
        buttons: [{ label: 'Buy', payload: 'buy1' }],
      },
    ],
    autoplay: false,
  },
  calendar: {
    type: 'calendar',
    label: 'Calendar',
    icon: 'i-lucide-calendar',
    content: 'Pick a date:',
    mode: 'single',
    min_date: '',
    max_date: '',
  },
  input: {
    type: 'input',
    label: 'Input',
    icon: 'i-lucide-keyboard',
    content: 'Enter value:',
    inputType: 'text',
    placeholder: 'Type...',
    title: '',
    description: '',
    required: false,
    minlength: 0,
    maxlength: 100,
    submit_label: 'Submit',
  },
  radio: {
    type: 'radio',
    label: 'Radio',
    icon: 'i-lucide-circle-dot',
    content: 'Select one:',
    options: [
      { label: 'Choice 1', payload: 'c1' },
      { label: 'Choice 2', payload: 'c2' },
    ],
    title: '',
    description: '',
    selected: '',
  },
  multiselect: {
    type: 'multiselect',
    label: 'Multiselect',
    icon: 'i-lucide-list',
    content: 'Select all that apply:',
    options: [
      { label: 'Option A', payload: 'a' },
      { label: 'Option B', payload: 'b' },
    ],
    title: '',
    description: '',
    min: 0,
    submit_label: 'Submit',
  },
  checkbox: {
    type: 'checkbox',
    label: 'Checkbox',
    icon: 'i-lucide-square-check',
    content: 'Check all that apply:',
    options: [
      { label: 'Option A', payload: 'a' },
      { label: 'Option B', payload: 'b' },
    ],
    title: '',
    description: '',
    min: 0,
    submit_label: 'Submit',
  },
  dropdown: {
    type: 'dropdown',
    label: 'Dropdown',
    icon: 'i-lucide-chevron-down',
    content: 'Pick one:',
    options: [
      { label: 'Option A', payload: 'a' },
      { label: 'Option B', payload: 'b' },
    ],
    title: '',
    description: '',
    placeholder: 'Select...',
    selected: '',
    submit_label: 'Submit',
  },
  latex: {
    type: 'latex',
    label: 'LaTeX',
    icon: 'i-lucide-superscript',
    content: '\\(x^2 + y^2 = z^2\\)',
    tts: 'Pythagorean theorem',
  },
  signature: {
    type: 'signature',
    label: 'Signature',
    icon: 'i-lucide-pen',
    content: 'Please sign here',
    description: 'Sign with your finger',
    submit_label: 'Sign',
  },
  userinput: {
    type: 'userinput',
    label: 'UserInput',
    icon: 'i-lucide-toggle-right',
    content: 'Enabled',
    enabled: true,
  },
  api: {
    type: 'api',
    label: 'API',
    icon: 'i-lucide-cloud',
    content: 'API status: {{response.get_info().status}}',
    apiUrl: 'https://api.example.com',
    apiMethod: 'GET',
    apiHeaders: '',
    apiBody: '',
    responseRules: [],
  },
  assign: {
    type: 'assign',
    label: 'Assign',
    icon: 'i-lucide-users',
    content: 'Assign to team or agent',
    assignType: 'team',
    teamId: '',
    agentId: '',
  },
  oauth: {
    type: 'oauth',
    label: 'OAuthRequest',
    icon: 'i-lucide-lock',
    content: 'Authenticate user',
    provider: 'google',
  },
  hold: {
    type: 'hold',
    label: 'Hold',
    icon: 'i-lucide-circle-pause',
    content: 'Wait for user input',
  },
  router: {
    type: 'router',
    label: 'Router',
    icon: 'i-lucide-git-branch',
    content: '',
    keywords: [{ match: '' }],
  },
  workinghours: {
    type: 'workinghours',
    label: 'Working Hours',
    icon: 'i-lucide-clock',
    content: 'Check if within working hours',
    enableWorkingHours: true,
    timezone: 'UTC',
    workingDays: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
    workingStart: '09:00',
    workingEnd: '17:00',
    outsideMessage:
      'We are currently closed. Our working hours are {start} - {end} ({timezone}). Please try again later.',
  },
};

// Start is placed for the user, and anything this stack cannot actually run
// is hidden rather than removed - see csmlNodeSupport.js.
export const PALETTE_ITEMS = NODE_TEMPLATE_TYPES.filter(
  type => type !== 'start' && isNodeTypeSupported(type)
).map(type => ({
  type,
  category: getNodeCategory(type),
  labelKey: `AGENT_BOTS.VISUAL_BUILDER.NODES.${type.toUpperCase()}.LABEL`,
  descKey: `AGENT_BOTS.VISUAL_BUILDER.NODES.${type.toUpperCase()}.DESC`,
  icon: nodeTemplates[type].icon,
}));

export function createNodeFromTemplate(type, overrides = {}) {
  const template = nodeTemplates[type];
  if (!template) return null;
  return {
    ...JSON.parse(JSON.stringify(template)),
    ...overrides,
  };
}
